import { BffBrandType } from '@shared-components/gqlConstants';
import { TAGBrand } from '@shared-components/types';

/**
 * Converts a TAGBrand enum value to its corresponding BffBrandType
 * @param brand - The TAGBrand enum value to convert
 * @returns The corresponding BffBrandType value
 *          Returns BffBrandType.Lovet for all brands in Lovet-only mode.
 */
export function brandThemeToFacilityBrand(_brand: TAGBrand): BffBrandType {
	return BffBrandType.Lovet;
}
